<template>
  <div>
    <div class="columns is-gapless has-bg-white">
      <div class="column is-narrow is-flex is-padding-small"
           :class="membre.status === 'pending' || membre.status === 'refused' ? 'has-bg-grey3 is-border-right' : 'has-bg-success'">
				<span class="icon is-self-centered"
                      :class="membre.status === 'pending' || membre.status === 'refused' ? 'has-text-danger' : 'has-text-white'">
					<i v-if="membre.status === 'pending'" class="fas fa-clock"></i>
          <i v-else-if="membre.status === 'refused'" class="fas fa-exclamation-circle"></i>
					<i v-else class="fas fa-check-circle"></i>
					</span>
      </div>
      <div class="column columns is-gapless is-padding-small is-multiline">
        <div class="column is-6 is-4-widescreen is-3-fullhd is-padding-xxsmall">
          <div class="label">
            <span v-if="membre.is_buyer">RÉSERVATAIRE / Acquéreur</span>
            <span v-else>RÉSERVATAIRE / CO-Acquéreur</span>
          </div>
          <div v-if="membre" class="title is-5 has-text-weight-medium">
            <div v-if="membre.nature === 'corporation'" class="is-uppercase">{{membre.corporation_name}}</div>
            <div v-if="membre.first_name && membre.last_name"><span
                    class="is-uppercase">{{membre.last_name}} </span><span style="text-transform: capitalize">{{membre.first_name}}</span>
            </div>
          </div>
        </div>
        <div class="column is-6 is-4-widescreen is-3-fullhd is-padding-xxsmall">
          <div class="label">
            <span>Adresse</span>
          </div>
          <div class="title is-5" v-if="membre && membre.address">
            <span v-if="membre.address.line1">{{membre.address.line1}}</span>
            <br v-if="membre.address.line1">
            <span v-if="membre.address.zip_code || membre.address.city">{{membre.address.zip_code}} {{membre.address.city}}</span>
            <br v-if="membre.address.zip_code || membre.address.city">
            <span v-if="membre.address.country">{{membre.address.country}}</span>
            <span v-if="!membre.address.line1 && !membre.address.zip_code &&
										!membre.address.country && !membre.address.city">
					NC
				</span>
          </div>
        </div>
        <div class="column is-12 is-4-widescreen is-6-fullhd columns is-gapless is-multiline">
          <div class="column is-6 is-12-widescreen is-6-fullhd is-padding-xxsmall">
            <div class="label">
              <span>Téléphone</span>
            </div>
            <div class="title is-5">
              {{membre.phone}}
            </div>
          </div>
          <div class="column is-6 is-12-widescreen is-6-fullhd is-padding-xxsmall">
            <div class="label">
              <span>Mail</span>
            </div>
            <div class="title is-5">
              <span>{{membre.email}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="membre.status !== 'refused' && procedure.status !== 'deleted'"
         class="columns is-gapless is-multiline has-bg-white is-border-top">
      <div :class="!(isAdmin || isSectorManager) && !isLRE ? 'is-12-widescreen' : 'is-6-widescreen'"
           class="is-12 column columns is-gapless is-centered is-padding-top is-border-right is-padding-bottom">
        <div
                class="column is-narrow has-badgeCustom--topright has-badgeCustom--out-quarter is-size-5 is-size-6-widescreen is-size-4-fullhd">
          <i v-if="membre.status === 'pending' || membre.status === 'refused'" class="fal fa-5x fa-file-alt"></i>
          <i v-else-if="membre.status === 'done'" class="fal fa-5x fa-file-contract"></i>
          <span v-if="membre.status === 'pending'"
                class="badgeCustom is-large is-bordered is-danger tooltip is-tooltip-top"
                data-tooltip="En attente de signature">
						<span class="icon"><i class="fas fa-clock"></i></span>
					</span>
          <span v-else-if="membre.status === 'done'"
                class="badgeCustom is-large is-bordered is-success tooltip is-tooltip-top" data-tooltip="Contrat signé">
						<span class="icon"><i class="fas fa-check"></i></span>
					</span>
          <span v-else-if="membre.status === 'refused'"
                class="badgeCustom is-large is-bordered is-danger tooltip is-tooltip-top" data-tooltip="Contrat refusé">
						<span class="icon"><i class="fas fa-exclamation"></i></span>
					</span>
        </div>
        <div class="column is-narrow is-margin-left-large is-padding-top-xxsmall">
          <div class="title is-3 is-marginless  has-text-weight-medium">Contrat de réservation</div>
          <div class="is-padding-bottom-xsmall">
            <span v-if="membre.status === 'done'" class="is-size-7 has-text-success is-uppercase">Signé le {{membre.updated_on | date}}</span>
            <span v-else-if="membre.status === 'refused'" class="is-size-7 has-text-danger is-uppercase">Signature refusée le {{membre.updated_on | date}}</span>
            <span
                    v-else-if="membre.status === 'pending' && procedure.status !== 'deleted' && procedure.status !== 'expired'"
                    class="is-size-7 has-text-danger is-uppercase">En attente de signature</span>
          </div>
          <div class="is-margin-top-xxsmall">
            <button
                    v-if="procedure.status === 'deleted' || procedure.status === 'expired' || procedure.status === 'refused' || !canSign"
                    :disabled="true"
                    class="button is-small is-success is-transform-none is-fullwidth is-radius">
              <span class="is-uppercase">Signer</span>
            </button>
            <button v-else-if="membre.status === 'done'" @click="openPreviewContratMembre()"
                    class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <div class="veryFastAnimation">
                <span>Contrat signé (.pdf)</span>
              </div>
            </button>
            <button v-else-if="procedure.status === 'finished'" @click="openPreviewContrat()"
                    class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <div class="veryFastAnimation">
                <span>Contrat signé (.pdf)</span>
              </div>
            </button>
            <button v-else @click="openPreview('contrat')"
                    class="button is-small is-success is-transform-none is-fullwidth is-radius">
              <span class="is-uppercase">Signer</span>
            </button>
          </div>
        </div>
      </div>
      <div class="column is-12 is-6-widescreen is-border-left columns is-gapless is-centered is-padding-top is-padding-bottom"
           v-if="lreEnabled && (isAdmin || isSectorManager || isLRE)">
        <div
                class="column is-narrow has-badgeCustom--topright has-badgeCustom--out-quarter is-size-5 is-size-6-widescreen is-size-4-fullhd">
          <i class="fal fa-5x fa-mail-bulk"></i>
          <span v-if="(membre.status === 'pending' && procedure.status !== 'deleted' && procedure.status !== 'expired') || !EveryBodySign"
                class="badgeCustom is-large is-bordered tooltip is-tooltip-top is-danger"
                data-tooltip="DISPONIBLE À LA FIN DE LA PROCÉDURE">
							<span class="icon">
								<i class="fas fa-clock"></i>
								</span>
					</span>
          <span v-else-if="membre.lre && membre.lre.status === 'waiting'"
                class="badgeCustom is-large is-bordered tooltip is-tooltip-top is-danger"
                data-tooltip="En attente de réception">
							<span class="icon">
								<i class="fas fa-clock"></i>
								</span>
					</span>
          <span v-else-if="membre.lre && membre.lre.status === 'ev'"
                class="badgeCustom is-large is-bordered tooltip is-tooltip-top is-success"
                data-tooltip="Envoyé">
							<span class="icon">
								<i class="fas fa-check"></i>
								</span>
					</span>
          <span v-else-if="membre.lre && membre.lre.status === 'dp'"
                class="badgeCustom is-large is-bordered tooltip is-tooltip-top is-success"
                data-tooltip="Livré">
							<span class="icon">
								<i class="fas fa-check"></i>
								</span>
					</span>
          <span v-else-if="membre.lre && membre.lre.status === 'ar'"
                class="badgeCustom is-large is-bordered tooltip is-tooltip-top is-success"
                data-tooltip="Recu">
							<span class="icon">
								<i class="fas fa-check"></i>
								</span>
					</span>
        </div>
        <div v-if="lreEnabled" class="column is-narrow is-margin-left-large is-padding-top-xxsmall">
          <div class="title is-3 is-marginless  has-text-weight-medium">Courrier recommandé</div>
          <div class="is-padding-bottom-xsmall">
            <span v-if="(membre.status === 'pending' && procedure.status !== 'deleted' && procedure.status !== 'expired') || !EveryBodySign"
                  class="is-size-7 is-uppercase has-text-danger">Disponible à la fin de la procédure</span>
            <span v-else-if="membre.lre && membre.lre.status === 'waiting'"
                  class="is-size-7 is-uppercase has-text-danger">En attente de réception</span>
            <span v-else-if="membre.lre && (membre.lre.status === 'ev' || membre.lre.status === 'dp')"
                  class="is-size-7 has-text-success is-uppercase">ENVOYÉ le {{membre.lre.updated_on | date}}</span>
            <span v-else-if="membre.lre && membre.lre.status === 'ar'" class="is-size-7 has-text-success is-uppercase">Recu le {{membre.lre.updated_on | date}}</span>
            <span v-else-if="membre.lre" class="is-size-7 has-text-success is-uppercase">Erreur lors de l'envoi : {{membre.lre.status}}</span>
          </div>
          <div class="is-margin-top-xxsmall"
               :class="{'is-padding-top-small' : (!membre.lre || membre.lre.failed) && EveryBodySign}">
            <button v-if="loadLre" class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <i class="fas fa-spinner fa-spin is-margin-xsmall"></i>
            </button>
            <button v-else-if="membre.lre && (membre.lre.status === 'ev' || membre.lre.status === 'dp' || membre.lre.status === 'waiting' || membre.lre.status === 'ar')"
                    class="button is-small is-light is-border is-transform-none is-fullwidth is-radius"
                    @click="openLreModal()">
              <span class="is-underline">Suivre procédure</span>
            </button>
            <button v-else-if="(membre.status === 'pending' && procedure.status !== 'deleted' && procedure.status !== 'expired') || !EveryBodySign"
                    :disabled="true"
                    class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <span class="is-uppercase">Envoyer LRE</span>
            </button>
            <button v-else-if="(!membre.lre || membre.lre.failed) && EveryBodySign" @click="sendLRE(membre.buyer_pk)"
                    class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
              <span class="is-uppercase">Envoyer LRE</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if='membre.comment' class="columns is-gapless is-border-top has-bg-warning is-padding-small">
      <div class="column is-12 is-padding-left-large">
        <div class="is-uppercase is-size-6"><b>PROCÉDURE ANNULÉE : Commentaires</b></div>
        <div class="is-padding-top-small is-size-7">{{membre.comment}}</div>
        <div class="is-padding-top-small is-size-6"><span><b>Date :</b></span> {{membre.updated_on | dateRefus}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { mapState, mapGetters } from 'vuex'

  export default {
    name: 'ContratItem',
    props: {
      membre: Object,
      signatures: Array,
      procedure: Object,
      idx: Number
    },
    data () {
      return {
        loadLre: false,
        panel: 'contrat',
        configDate: {
          altFormat: 'j/m/Y',
          altInput: true,
          dateFormat: 'd/m/Y'
        }
      }
    },
    filters: {
      date: function (value) {
        let date = moment(value).format('DD/MM/YYYY')
        let hour = moment(value).format('HH')
        let minute = moment(value).format('mm')

        return date + ' à ' + hour + 'h' + minute
      },
      dateRefus: function (value) {
        let date = moment(value).format('DD/MM/YYYY')
        let hour = moment(value).format('HH')
        let minute = moment(value).format('mm')

        return date + ' - ' + hour + ':' + minute
      }
    },
    computed: {
      ...mapGetters(['isAdmin', 'isSectorManager']),
      ...mapState(['configs']),
      isLre () {
        return this.membre.lre !== null
      },
      lreEnabled () {
        if ('LRE_ENABLED' in this.configs && this.configs.LRE_ENABLED) {
          return this.configs.LRE_ENABLED.toString() === '1'
        }
        return false
      },
      yousignSignatureUrl () {
        return this.configs.YOUSIGN_URL
      },
      yousignSignatureId () {
        return this.configs.YOUSIGN_SIGNATURE_ID
      },
      signature () {
        return this.signatures.find(x => {
          return x.buyer === this.membre.buyer_pk
        })
      },
      EveryBodySign () {
        let contratSign = []
        this.procedure.members.forEach(x => {
          if (x.status === 'done') contratSign.push(x.status)
        })
        return contratSign.length === this.procedure.members.length
      },
      canSign () {
        if (this.idx === 0) {
          return true
        } else if (this.idx === 1) {
          if (this.procedure.members[0].status === 'pending') {
            return false
          } else {
            return true
          }
        } else if (this.idx === 2) {
          if (this.procedure.members[1].status === 'pending' || this.procedure.members[0].status === 'pending') {
            return false
          } else {
            return true
          }
        }
      }
    },
    methods: {
      async sendLRE (buyer) {
        this.loadLre = true
        let request
        try {
          request = await this.$api.advService.postLre(this.procedure.adv, {
            buyer
          })
        } catch (e) {
          this.loadLre = false
          console.log(request)
        }
        this.loadLre = false
      },
      openLreModal () {
        let params = {
          lre: this.membre.lre,
          buyer: this.membre,
          advPk: this.procedure.adv
        }
        this.$store.commit('setModal', { mode: 'PROCEDURE_MODAL', params })
      },
      openPreviewContrat () {
        const apiUrl = this.$configs.APIROOT
        let link = document.createElement('a')
        link.href = apiUrl + '/yousign-file/' + this.procedure.file_id
        link.target = '_blank'
        link.click()
      },
      openPreviewContratMembre () {
        const apiUrl = this.$configs.APIROOT
        let link = document.createElement('a')
        link.href = apiUrl + '/yousign-file/' + this.membre.file_id
        link.target = '_blank'
        link.click()
      },
      changePanel () {
        if (this.membre.comment) {
          this.panel = 'contrat'
        }
      },
      update (value, elem) {
        if (elem === 'numero_ar') this.signature.numero_ar = value
        this.$emit('commitAdv')
      },
      deleteAr () {
        this.signature.numero_ar = null
        this.$emit('commitAdv')
      },
      openPreview (elem) {
        if (elem === 'contrat') {
          let params = {
            link: this.yousignSignatureUrl + '/procedure/sign?members=/members/' + this.membre.yousign_id
          }
          this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW', params })
        } else if (elem === 'contrat_sign') {
          const apiUrl = this.$configs.APIROOT
          let link = document.createElement('a')
          link.href = apiUrl + '/yousign-file/' + this.membre.file_id
          link.target = '_blank'
          link.click()
        } else if (elem === 'justificatif') {
          let params = {
            idAdv: this.procedure.adv,
            linkEmbed: this.membre.lre.proof
          }
          this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW', params })
        }
      }
    },
    created () {
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/adv/FeuilleDeRoute/ContratItem.vue